import qs from "qs";

export class Payment {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/payment`;
  }

  async getPaymentCampaigns() {
    const url = `${this.baseURL}/rj_payment_gateway/campaigns`;
    const response = await this.httpClient.request("get", url);
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/payment.js